import app from './index';

runBlock.$inject = ['$location', '$resource', '$window', 'localStorageService', '$q', '$http', '$translate'];

export default function runBlock($location, $resource, $window, localStorageService, $q, $http, $translate) {
  'ngInject';

  if ($location.$$host === 'localhost') {
    app.serviceBase = 'http://localhost:5000';
  } else {
    app.serviceBase = 'https://api.technische-klebeschilder.de';
  }

  app.artikel = [];
  app.kontakt = {};
  app.$location = $location;
  app.$window = $window;
  app.translate = $translate;
  app.authData = localStorageService.get('authorizationData');
  app.language = $translate.preferredLanguage();

  app.login = (username, password) => {
    let deferred = $q.defer();

    let req = {
      method: 'POST',
      url: app.serviceBase + "/login",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: "grant_type=password&username=" + username + "&password=" + password,
    };

    $http(req)
      .then((response) => {
        app.authData = {
          /*jshint camelcase: false */
          token: response.data.token,
          username: username
        };
        localStorageService.set('authorizationData', app.authData);
        window.toastr.info("Erfolgreich angemeldet");
        deferred.resolve(response);
      }, () => {
        app.logout();
        window.toastr.error("Fehler bei Anmeldung");
      });

    return deferred.promise;
  };

  app.logout = () => {
    localStorageService.remove('authorizationData');
    app.authData = null;
  };

  app.clearCard = () => {
    app.artikel = [];
  };

  app.addToCard = (artikel) => {
    if (artikel.menge) {
      app.artikel.push(artikel);
    }
  };

  app.isAuth = () => {
    return app.authData !== null;
  };

  app.api = {
    kontakte: $resource(app.serviceBase + '/kontakte'),
    artikelKategorien: $resource(app.serviceBase + '/artikel-kategorien'),
    kunden: $resource(app.serviceBase + '/kunden/:id', {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      }
    }),
    artikel: $resource(app.serviceBase + '/artikel/:id', {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      },
      'lagerBestandAktualisieren': {
        method: 'POST',
        isArray: false,
        url: app.serviceBase + '/artikel/lager/aktualisieren'
      }
    }),
    anfragen: $resource(app.serviceBase + '/anfragen/:id', {
      id: '@id'
    }, {
      'gelesen': {
        method: 'POST',
        isArray: false,
        url: app.serviceBase + '/anfragen/:id/gelesen'
      }
    }),
    rechnungen: $resource(app.serviceBase + '/rechnungen/:id', {
      id: '@id'
    }, {
      'query': {
        method: 'GET',
        isArray: true
      },
      'stornieren': {
        method: 'POST',
        isArray: false,
        url: app.serviceBase + '/rechnungen/:id/stornieren'
      },
      'bezahlen': {
        method: 'POST',
        isArray: false,
        url: app.serviceBase + '/rechnungen/:id/bezahlen'
      },
      'aendern': {
        // Rechnung stornieren und neue Rechnung erzeugen
        method: 'GET',
        isArray: false,
        url: app.serviceBase + '/rechnungen/:id/aendern'
      }
    })
  };
}



// WEBPACK FOOTER //
// ./app/index.run.js